import { render, staticRenderFns } from "./CardResult.vue?vue&type=template&id=45a26018&scoped=true"
import script from "./CardResult.vue?vue&type=script&lang=js"
export * from "./CardResult.vue?vue&type=script&lang=js"
import style0 from "./CardResult.vue?vue&type=style&index=0&id=45a26018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a26018",
  null
  
)

export default component.exports